let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("imB10")).then(() => parcelRequire('in7zw'));